import { Icon } from '@/components/icon/Icon.tsx';
import { balanceHiddenPlaceholder } from '@/lib/_utils/index.tsx';
import useTralentStore from '@/stores/index.ts';
import {useCurrencyFormatter} from "@/lib/_hooks/useUserCurrency.ts";

const HeaderBalance = () => {
	const { balance, isBalanceHidden, setIsBalanceHidden, isLoading } = useTralentStore();
	const {amountWithUserCurrency} = useCurrencyFormatter();

	return (
		<div className='flex items-center lg:h-[40px] lg:bg-dark-900 lg:px-4'>
			{!isLoading && (
				<>
					<div className='group mr-[8px] cursor-pointer select-none transition-opacity hover:opacity-70 active:opacity-50'>
						{isBalanceHidden ? (
							<Icon
								name='eyeClosedOutlined'
								className={`opacity-0 ${isBalanceHidden ? '!opacity-100' : ''} transition-opacity`}
								onClick={() => setIsBalanceHidden(false)}
							/>
						) : (
							<>
								<Icon name='walletIcon' id='balanceWalletIcon' className={`transition-opacity group-hover:hidden`} />
								<Icon
									name='eyeOpenOutlined'
									id='balanceEyeIcon'
									onClick={() => setIsBalanceHidden(true)}
									className={`hidden transition-opacity group-hover:flex`}
								/>
							</>
						)}
					</div>
					<div className='text-md'>{isBalanceHidden ? balanceHiddenPlaceholder : amountWithUserCurrency(balance)}</div>
				</>
			)}
		</div>
	);
};

export default HeaderBalance;
